import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faReply, faExternalLinkAlt, faPhone, faClone, faBolt,
    faImage, faVideo, faFile, faShoppingCart
} from '@fortawesome/free-solid-svg-icons';
import './shared.css';

const WhatsAppPreview = ({
    header = {},
    body = '',
    footer = '',
    buttons = [],
    carousel = null
}) => {

    const formatWhatsAppText = (text) => {
        if (!text) return null;
        let formatted = text.replace(/\*(.*?)\*/g, '<b>$1</b>');
        formatted = formatted.replace(/_(.*?)_/g, '<i>$1</i>');
        formatted = formatted.replace(/~(.*?)~/g, '<strike>$1</strike>');
        formatted = formatted.replace(/```(.*?)```/g, '<code>$1</code>');
        return <div dangerouslySetInnerHTML={{ __html: formatted.replace(/\n/g, '<br />') }} />;
    };

    const getButtonIcon = (type) => {
        switch (type) {
            case 'QUICK_REPLY': return faReply;
            case 'URL': return faExternalLinkAlt;
            case 'PHONE_NUMBER': return faPhone;
            case 'COPY_CODE': return faClone;
            case 'FLOW': return faBolt;
            default: return null;
        }
    };

    const renderHeader = (hdr) => {
        if (!hdr || hdr.type === 'NONE') return null;

        const mediaTypes = ['IMAGE', 'VIDEO', 'DOCUMENT', 'PRODUCT'];
        if (mediaTypes.includes(hdr.type)) {
            return (
                <div className={`wa-header-media ${hdr.type.toLowerCase()}`}>
                    {hdr.type === 'IMAGE' && (
                        (hdr.mediaPreviewUrl || hdr.mediaFile) ?
                            <img src={hdr.mediaPreviewUrl} className="wa-header-img" alt="Header" /> :
                            <div className="wa-header-placeholder">
                                <FontAwesomeIcon icon={faImage} size="3x" />
                            </div>
                    )}
                    {hdr.type === 'VIDEO' && (
                        <div className="wa-header-placeholder">
                            <FontAwesomeIcon icon={faVideo} size="2x" />
                            <span>VIDEO HEADER</span>
                        </div>
                    )}
                    {hdr.type === 'DOCUMENT' && (
                        <div className="wa-header-placeholder">
                            <FontAwesomeIcon icon={faFile} size="2x" />
                            <span>DOCUMENT HEADER</span>
                        </div>
                    )}
                    {hdr.type === 'PRODUCT' && (
                        <div className="wa-header-placeholder">
                            <FontAwesomeIcon icon={faShoppingCart} size="2x" />
                            <span>PRODUCT HEADER</span>
                        </div>
                    )}
                </div>
            );
        }

        if (hdr.type === 'TEXT' && hdr.text) {
            return <div className="wa-header-text">{formatWhatsAppText(hdr.text)}</div>;
        }
        return null;
    };

    return (
        <div className="wa-preview-wrapper" id="preview-wrapper">
            <div className="wa-preview-device">
                <div className="wa-preview-header">
                    <div className="wa-preview-avatar"></div>
                    <div className="wa-preview-name">WaitWhiz</div>
                </div>

                <div className="wa-preview-content">
                    <div className="wa-message-bubble">
                        {/* Header */}
                        {renderHeader(header)}

                        {/* Body */}
                        <div className="wa-body-text">
                            {formatWhatsAppText(body || 'Message body...')}
                        </div>

                        {/* Carousel */}
                        {carousel && carousel.cards && carousel.cards.length > 0 && (
                            <div className="wa-carousel-container">
                                {carousel.cards.map((card, idx) => (
                                    <div key={idx} className="wa-carousel-card">
                                        <div className="wa-carousel-header">
                                            {carousel.type === 'MEDIA' && card.headerType === 'IMAGE' && (
                                                card.mediaPreviewUrl ?
                                                    <img src={card.mediaPreviewUrl} className="wa-header-img" alt="Card" /> :
                                                    <FontAwesomeIcon icon={faImage} size="2x" color="#9CA3AF" />
                                            )}
                                            {carousel.type === 'MEDIA' && card.headerType === 'VIDEO' && (
                                                <FontAwesomeIcon icon={faVideo} size="2x" color="#9CA3AF" />
                                            )}
                                            {/* Product Carousel default image */}
                                            {carousel.type === 'PRODUCT' && (
                                                <FontAwesomeIcon icon={faShoppingCart} size="2x" color="#9CA3AF" />
                                            )}
                                        </div>
                                        <div className="wa-carousel-body">
                                            {formatWhatsAppText(card.bodyText || '')}
                                        </div>
                                        {(card.buttons || []).map((btn, bIdx) => {
                                            // Determine icon if not set in btn (fallback for carousel config)
                                            let icon = getButtonIcon(btn.type); // If button object has type

                                            // If using config slots lookup (legacy/complex logic handled by parent mapping to simple button obj preferably)
                                            // Assuming parent passes formatted buttons: { type, text }

                                            return (
                                                <div key={bIdx} className="wa-btn" style={{ fontSize: '13px', padding: '10px 0px 10px 0px' }}>
                                                    {icon && <FontAwesomeIcon icon={icon} size="sm" />}
                                                    {btn.text}
                                                </div>
                                            );
                                        })}
                                        {/* Product View Button */}
                                        {carousel.type === 'PRODUCT' && carousel.buttonMode === 'DEFAULT' && (
                                            <div className="wa-btn" style={{ fontSize: '13px', padding: '10px 0px 10px 0px' }}>
                                                <FontAwesomeIcon icon={faExternalLinkAlt} size="sm" /> View
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}

                        {/* Footer */}
                        {footer && <div className="wa-footer-text">{footer}</div>}

                        <div className="wa-meta-time">12:30 PM</div>

                        {/* Buttons (Standard) */}
                        {!carousel && buttons && buttons.length > 0 && (
                            <div className="wa-btn-container">
                                {buttons.map((btn, idx) => (
                                    <div key={idx} className="wa-btn">
                                        {getButtonIcon(btn.type) && <FontAwesomeIcon icon={getButtonIcon(btn.type)} size="sm" />}
                                        {btn.text}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div style={{ marginTop: '16px', color: '#54656f', fontSize: '13px' }}>
                Preview acts as an approximation.
            </div>
        </div>
    );
};

export default WhatsAppPreview;
